import { render, staticRenderFns } from "./realEstateFeature.vue?vue&type=template&id=4f04dc5c&scoped=true&"
import script from "./realEstateFeature.vue?vue&type=script&lang=js&"
export * from "./realEstateFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04dc5c",
  null
  
)

export default component.exports